export default {"src":"/_next/static/media/check.b1f91633.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};